import React from 'react';
import UploadPage from './components/UploadPage';

function App() {
  return <UploadPage />;
}

export default App;
